import React from 'react';
import {
  Box,
  Typography,
  Stack,
} from '@mui/material';
import OperationCard from './OperationCard';
import { Operation } from '../../../../networkRequest/operationsService';
import { useOperationActions } from '../../../../hooks/useOperationActions';
import { ArchiveConfirmation } from '../../components';

interface OperationCardListProps {
  operations: Operation[];
  loading: boolean;
  statusFilter: string;
  onOperationsChange: (operations: Operation[]) => void;
  onError: (error: string) => void;
  allOperations: Operation[]; // Add full operations list
}

const OperationCardList: React.FC<OperationCardListProps> = ({
  operations,
  loading,
  statusFilter,
  onOperationsChange,
  onError,
  allOperations
}) => {
  // Use shared operation actions hook
  const {
    duplicating,
    confirmArchiveOpen,
    operationToArchive,
    handleDuplicate,
    handleArchiveClick,
    handleArchiveConfirm,
    handleArchiveCancel
  } = useOperationActions({
    onError,
    onOperationsChange,
    allOperations
  });



  if (operations.length === 0 && !loading) {
    return (
      <Box sx={{ textAlign: 'center', py: 4 }}>
        <Typography variant="h6" sx={{
          color: "text.secondary"
        }}>
          No operations found
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            mt: 1
          }}>
          {statusFilter === 'All'
            ? 'Create your first operation to get started.'
            : `No operations with status "${statusFilter}" found.`
          }
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <Stack spacing={2}>
        {operations.map((op) => (
          <OperationCard
            key={op.id}
            operation={op}
            onDuplicate={handleDuplicate}
            onArchive={handleArchiveClick}
            duplicating={duplicating}
          />
        ))}
      </Stack>

      {/* Archive Confirmation Dialog */}
      <ArchiveConfirmation
        open={confirmArchiveOpen}
        operationTitle={operationToArchive}
        onConfirm={handleArchiveConfirm}
        onCancel={handleArchiveCancel}
      />
    </>
  );
};

export default OperationCardList;